import {useEffect} from 'react';

const HomeApp = () => {
    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <img
                src={process.env.REACT_APP_VL_LOGO_URL}
                alt="Logo"
                style={{
                    maxWidth: '300px',
                    height: 'auto',
                }}
            />
        </div>
    );
};

export default HomeApp;